import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BackspaceNavigation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyPress = (event) => {
      const target = event.target;

      if (
        event.key === "Backspace" &&
        target &&
        !target.isContentEditable &&
        target.tagName !== "INPUT" &&
        target.tagName !== "TEXTAREA"
      ) {
        navigate(-1);
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [navigate]);

  return null;
};

export default BackspaceNavigation;
